var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgApprox(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5997 6.13314C12.0663 6.73314 11.0663 7.33314 9.99967 7.33314C8.99967 7.33314 8.39967 6.99981 7.86634 6.73314C7.33301 6.53314 6.79967 6.19981 5.93301 6.19981C5.13301 6.19981 4.39967 6.66647 3.99967 7.06647L3.33301 6.06647C3.93301 5.46647 4.86634 4.7998 5.93301 4.7998C6.93301 4.7998 7.53301 5.19981 8.06634 5.39981C8.59967 5.59981 9.13301 5.9998 9.99967 5.9998C10.7997 5.9998 11.533 5.46647 11.933 5.06647L12.5997 6.13314ZM12.6663 9.39981C12.0663 9.9998 11.133 10.6665 10.0663 10.6665C9.06634 10.6665 8.46634 10.3331 7.93301 10.0665C7.39967 9.86647 6.86634 9.46647 5.99967 9.46647C5.19967 9.46647 4.46634 9.9998 4.06634 10.3998L3.39967 9.33314C3.99967 8.73314 4.93301 8.06647 5.99967 8.06647C6.99967 8.06647 7.59967 8.3998 8.13301 8.66647C8.66634 8.86647 9.19967 9.19981 10.0663 9.19981C10.8663 9.19981 11.5997 8.66647 11.9997 8.26647L12.6663 9.39981Z",
    fill: "#24252A"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApprox);
export default __webpack_public_path__ + "static/media/Approx.2a8540a921f50038830219b4c34d83d2.svg";
export { ForwardRef as ReactComponent };